export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const AUTHOR_LOGIN = "AUTHOR_LOGIN";
export const AUTHOR_LOGOUT = "AUTHOR_LOGOUT";

export const ADMIN_LOGIN = "ADMIN_LOGIN";
export const ADMIN_LOGOUT = "ADMIN_LOGOUT";


export const STORE_BOOK = "STORE_BOOK";
